import { render, staticRenderFns } from "./AudioCenter.vue?vue&type=template&id=49caf4fd&scoped=true"
import script from "./AudioCenter.vue?vue&type=script&lang=js"
export * from "./AudioCenter.vue?vue&type=script&lang=js"
import style0 from "./AudioCenter.vue?vue&type=style&index=0&id=49caf4fd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49caf4fd",
  null
  
)

export default component.exports